import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

require('./EquipmentsOverviewPage.less');

const EquipmentsOverviewPage: FC<any> = ({ history, childRoutes }) => {
	const handleTabChange = useCallback(
		(key) => history.push(`/supplier/equipments/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = useMemo(
		() => [
			{
				key: 'all',
				name: 'All',
			},
			{
				key: 'templates',
				name: 'Types',
			},
			{
				key: 'priceList',
				name: 'Price List',
			},
		],
		[]
	);

	return (
		<>
			<Route
				path="/supplier/equipments/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/equipments/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Equipment"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="equipmentsPage"
				creationRoutes={['new', 'new_template']}
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(EquipmentsOverviewPage)
);
